export const TEXT_SECONDARY_COLOR = 'text.secondary';

export const CENTERED_PAGE_BOX_SX = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '50vh',
} as const;

export const ENTITY_TYPE_LABELS: Record<string, string> = {
  INDIVIDUAL: 'Individual',
  TRUST: 'Trust',
  COMPANY: 'Company',
  SMSF: 'SMSF',
  PARTNERSHIP: 'Partnership',
};

export function getEntityTypeLabel(type: string): string {
  return ENTITY_TYPE_LABELS[type] || type;
}
